import { render } from "./ExamTemplateMake.vue?vue&type=template&id=324be248&scoped=true"
import script from "./ExamTemplateMake.vue?vue&type=script&lang=js"
export * from "./ExamTemplateMake.vue?vue&type=script&lang=js"

import "./ExamTemplateMake.vue?vue&type=style&index=0&id=324be248&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-324be248"]])

export default __exports__